import React, { useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { X, MessageCircle } from 'lucide-react';
import { fireDB as db, appId } from '../../services/firebase';

export default function FeedbackModal({ user, onClose }) {
  const [category, setCategory] = useState('오타 오기 제보');
  const [content, setContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setIsSubmitting(true);

    // 카테고리 텍스트를 AdminView에서 사용하는 영문 코드로 변환
    let reportType = 'etc';
    if (category === '오타 오기 제보') reportType = 'typo';
    if (category === '개선사항 건의하기') reportType = 'suggest';

    try {
      // AdminView가 읽어오는 'reports' 컬렉션으로 경로 수정
      await addDoc(collection(db, 'artifacts', appId, 'reports'), {
        userId: user.uid,
        userEmail: user.email || '',
        type: reportType,      // 필터링을 위한 타입 (typo, suggest, etc)
        category: category,    // 표시용 카테고리 이름
        userText: content,     // AdminView에서 읽는 필드명으로 저장
        status: 'pending',     // 초기 상태
        createdAt: serverTimestamp(),
        timestamp: serverTimestamp(),
      });
      alert('소중한 의견 감사합니다.');
      onClose();
    } catch (error) {
      console.error(error);
      alert('오류가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
      <div className="bg-slate-800 w-full max-w-md rounded-2xl border border-slate-700 shadow-2xl p-6 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white">
          <X className="w-6 h-6" />
        </button>
        <h3 className="text-xl font-bold text-white mb-4 flex items-center">
          <MessageCircle className="w-6 h-6 mr-2 text-indigo-400" /> 제보 및 건의하기
        </h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-400 mb-1">카테고리</label>
            <select className="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white" value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="오타 오기 제보">오타 오기 제보</option>
              <option value="개선사항 건의하기">개선사항 건의하기</option>
              <option value="기타">기타</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-400 mb-1">내용</label>
            <textarea className="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white h-32 resize-none" value={content} onChange={(e) => setContent(e.target.value)} required />
          </div>
          <button type="submit" disabled={isSubmitting} className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-3 rounded-lg">
            {isSubmitting ? '전송 중...' : '작성 완료'}
          </button>
        </form>
      </div>
    </div>
  );
}